// JsFromRoutes CacheKey 4328e43bbc2ed75af0f33017ffedea7b
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@corp/services/api'

export default {
  search: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/giftly_groupings/search'),
  typeaheadSelect: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/giftly_groupings/typeahead_select'),
  duplicate: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/giftly_groupings/:id/duplicate'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/consumer/giftly_groupings'),
  create: /* #__PURE__ */ definePathHelper('post', '/admin/consumer/giftly_groupings'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/consumer/giftly_groupings/:id'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/admin/consumer/giftly_groupings/:id'),
}
